// extracted by mini-css-extract-plugin
module.exports = {"ShootAddress":"ChooseAppointment_ShootAddress__FRgz4","ShootAddressText":"ChooseAppointment_ShootAddressText__n0jK-"};